/**
 * ScrollToTop - Scroll to top on route change
 * 
 * React Router does client-side navigation without page reload,
 * so scroll position persists between routes. This component
 * fixes that by scrolling to top whenever the pathname changes.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}
